import openModal from '@PROJECT_ROOT/assets/shared/js/modalBox';

export default function openSyncWithMapDialog(texts, onYesClick, onNoClick) {
    const dialogTitleParagraph = document.createElement('p');
    dialogTitleParagraph.textContent = texts.syncDialogTitleText;

    const syncWithMapButton = document.createElement('button');
    syncWithMapButton.textContent = texts.syncWithMapButtonText;

    const dontSyncWithMapButton = document.createElement('button');
    dontSyncWithMapButton.textContent = texts.dontSyncWithMapButtonText;

    // Za potrebe testa botunima dodajemo atribute.
    if (process.env.NODE_ENV !== 'production') {
        syncWithMapButton.setAttribute('data-testid', 'yes-button');
        dontSyncWithMapButton.setAttribute('data-testid', 'no-button');
    }

    const syncDialogContainer = document.createElement('div');
    syncDialogContainer.appendChild(dialogTitleParagraph);
    syncDialogContainer.appendChild(syncWithMapButton);
    syncDialogContainer.appendChild(dontSyncWithMapButton);

    const closeModal = openModal(syncDialogContainer, {
        overlayCss: ['syncDialogContainer'],
    });

    syncWithMapButton.addEventListener('click', () => {
        onYesClick();
        closeModal();
    });

    dontSyncWithMapButton.addEventListener('click', () => {
        onNoClick();
        closeModal();
    });
}
